import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import { questionBankGridSx } from './QuestionBankContentPanel'

/** Figma 6074:13379 — card row height ~176px. */
const SKELETON_CARD_HEIGHT_PX = 176

export function QuestionBankPageSkeleton() {
  return (
    <Box
      data-testid="question-bank-page-skeleton"
      aria-busy
      aria-label="Loading Question Bank"
      sx={questionBankGridSx}
    >
      {Array.from({ length: 6 }, (_, i) => (
        <Skeleton
          key={i}
          variant="rounded"
          height={SKELETON_CARD_HEIGHT_PX}
          sx={{ borderRadius: '12px' }}
        />
      ))}
    </Box>
  )
}
